import React, {ReactNode} from 'react';
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';
import type {VerticalSize} from 'react-virtualized-auto-sizer';
import {ListChildComponentProps, ListOnScrollProps} from 'react-window';
import {SelectProps} from '@guestapp/old-ui-kit';
import {Menu} from './styled';

const INIT_OFFSET = 0;
const THRESHOLD = 5;

const plugLoadMoreFunction = () => null;

type VirtualizedListProps<T, V, L> = {
  children?: (props: ListChildComponentProps) => ReactNode;
  isMoreItemsLoading: boolean;
  itemSize: number;
  height: number | string;
  width: number | string;
  options: SelectProps<T, V, L>['options'];
  itemCount: number;
  loadMoreItems?: () => void;
  listAutoSizer?: boolean;
  mobileVersion?: boolean;
  canLoadMore?: boolean;
};
function VirtualizedList<T, V, L>({
  children,
  canLoadMore,
  isMoreItemsLoading,
  loadMoreItems,
  listAutoSizer,
  mobileVersion,
  itemSize,
  height,
  width,
  options,
  itemCount,
}: VirtualizedListProps<T, V, L>) {
  const scrollOffsetRef = React.useRef(0);
  const loadMore =
    isMoreItemsLoading || !canLoadMore
      ? plugLoadMoreFunction
      : loadMoreItems || plugLoadMoreFunction;
  const isItemLoaded = (index: number) => Boolean(options?.[index]);

  return (
    // @ts-expect-error ts(2604)
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={loadMore}
      threshold={THRESHOLD}
    >
      {({onItemsRendered, ref}) => {
        return listAutoSizer ? (
          <AutoSizer ref={ref} disableWidth>
            {({height}: VerticalSize) => (
              <Menu
                onScroll={({scrollOffset}: {scrollOffset: number}) => {
                  scrollOffsetRef.current = scrollOffset;
                }}
                onItemsRendered={onItemsRendered}
                initialScrollOffset={
                  isMoreItemsLoading ? INIT_OFFSET : scrollOffsetRef.current
                }
                itemCount={itemCount}
                itemSize={itemSize}
                height={height}
                width={width}
                mobileVersion={mobileVersion}
                className="infinite-scroll-select__menu"
              >
                {children}
              </Menu>
            )}
          </AutoSizer>
        ) : (
          <Menu
            ref={ref}
            onScroll={({scrollOffset}: ListOnScrollProps) => {
              scrollOffsetRef.current = scrollOffset;
            }}
            onItemsRendered={onItemsRendered}
            initialScrollOffset={
              isMoreItemsLoading ? INIT_OFFSET : scrollOffsetRef.current
            }
            itemCount={itemCount}
            width={width}
            itemSize={itemSize}
            height={height}
            mobileVersion={mobileVersion}
            className="infinite-scroll-select__menu"
          >
            {children}
          </Menu>
        );
      }}
    </InfiniteLoader>
  );
}

export {VirtualizedList};
